import apiClient, { withAuth } from './api';

export const carrierService = {
  // Carriers
  getAllCarriers: (token) => {
    return apiClient.get('/api/carriers/', withAuth(token));
  },
  
  getCarrierDetails: (slug, token) => {
    return apiClient.get(`/api/carriers/${slug}/`, withAuth(token));
  },
  
  // Carrier plans
  getAllCarrierPlans: (token) => {
    return apiClient.get('/api/carrier-plans/', withAuth(token));
  },
  
  getCarrierPlanDetails: (slug, token) => {
    return apiClient.get(`/api/carrier-plans/${slug}/`, withAuth(token));
  },
  
  getCarrierPlans: (carrierSlug, token) => {
    return apiClient.get(`/api/carriers/${carrierSlug}/plans/`, withAuth(token));
  }
};

export default carrierService;